import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { getInStoreBranchInfo } from '../utils/inStoreBranchInfo';

const InStoreOnlyModal = ({ show, onHide, settings, isCasaRegion, productName }) => {
  const branch = getInStoreBranchInfo(settings, isCasaRegion);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="in-store-only-modal"
      contentClassName="border border-gray-100 rounded-24 overflow-hidden"
    >
      <Modal.Header closeButton className="border-bottom border-gray-100 px-24 py-16">
        <Modal.Title className="text-heading fw-bold" style={{ fontSize: '1.125rem' }}>
          Disponible sur place uniquement
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-24 py-20">
        <p className="text-gray-700 mb-16" style={{ lineHeight: 1.55 }}>
          {productName ? (
            <>
              <span className="fw-semibold text-heading">{productName}</span> se consomme sur place dans
              nos points de vente à {branch.regionLabel}. La commande en ligne et la livraison ne sont pas
              disponibles pour ce produit.
            </>
          ) : (
            <>
              Ce produit se consomme sur place dans nos points de vente à {branch.regionLabel}. La commande
              en ligne et la livraison ne sont pas disponibles.
            </>
          )}
        </p>

        {branch.addresses.length > 0 && (
          <div className="mb-16">
            <div className="text-heading fw-semibold mb-8">Adresse{branch.addresses.length > 1 ? 's' : ''}</div>
            <ul className="list-unstyled mb-0">
              {branch.addresses.map((address) => (
                <li key={address} className="text-gray-700 flex-align gap-8 mb-6">
                  <i className="ph ph-map-pin text-main-600" aria-hidden="true" />
                  <span>{address}</span>
                </li>
              ))}
            </ul>
          </div>
        )}

        {branch.phones.length > 0 && (
          <div>
            <div className="text-heading fw-semibold mb-8">Contact</div>
            <ul className="list-unstyled mb-0">
              {branch.phones.map((phone) => (
                <li key={phone} className="mb-6">
                  <a
                    href={`tel:${phone.replace(/\s/g, '')}`}
                    className="text-main-600 fw-semibold text-decoration-none flex-align gap-8"
                  >
                    <i className="ph ph-phone" aria-hidden="true" />
                    {phone}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="border-top border-gray-100 px-24 py-16">
        <Button className="btn btn-main rounded-pill px-32" onClick={onHide}>
          J&apos;ai compris
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InStoreOnlyModal;
